exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nil-sa-widget__widgetContainer{width:100%;height:100%;font-size:14px;overflow-x:clip}.nil-sa-widget__widgetContainer,.nil-sa-widget__widgetContainer div,.nil-sa-widget__widgetContainer form,.nil-sa-widget__widgetContainer input{position:relative;display:block;box-sizing:border-box}.nil-sa-widget__widgetContainer strong{font-size:1.12em}.nil-sa-widget__widgetContainer.roboto,.nil-sa-widget__widgetContainer.roboto button{font-family:Roboto,sans-serif}.nil-sa-widget__widgetContainer a{color:#388efb;text-decoration:none}.nil-sa-widget__widgetContainer a:hover{color:#388efb}.nil-sa-widget__widgetContainer label{position:relative;display:block;font-weight:700}.nil-sa-widget__widgetContainer .nil-sa-widget__fa{color:#000!important}.nil-sa-widget__widgetContainer .nil-sa-widget__containerPage{position:relative}.nil-sa-widget__widgetContainer .nil-sa-widget__containerFooter{position:relative;text-align:right;width:100%;font-size:20px;padding-top:40px}", ""]);

// exports
exports.locals = {
	"widgetContainer": "nil-sa-widget__widgetContainer",
	"fa": "nil-sa-widget__fa",
	"containerPage": "nil-sa-widget__containerPage",
	"containerFooter": "nil-sa-widget__containerFooter"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-2!../node_modules/postcss-loader/lib??ref--2-3!../node_modules/less-loader/dist/cjs.js??ref--2-4!./components/widget/index.less
// module id = 215
// module chunks = 0